"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneratorUtils = void 0;

var GeneratorUtils = /*#__PURE__*/function () {
  function GeneratorUtils() {
    _classCallCheck(this, GeneratorUtils);
  }

  _createClass(GeneratorUtils, null, [{
    key: "bufferToUint64",
    value: function bufferToUint64(input) {
      var view = new DataView(input.slice(0, 8).reverse().buffer);
      return [view.getUint32(4), view.getUint32(0)];
    }
  }, {
    key: "readUint32At",
    value: function readUint32At(bytes, index) {
      return bytes[index] + (bytes[index + 1] << 8) + (bytes[index + 2] << 16) + (bytes[index + 3] << 24) >>> 0;
    }
  }, {
    key: "uintToBuffer",
    value: function uintToBuffer(uintValue, bufferSize) {
      var buffer = new ArrayBuffer(bufferSize);
      var dataView = new DataView(buffer);

      try {
        if (1 === bufferSize) {
          dataView.setUint8(0, uintValue);
        } else if (2 === bufferSize) {
          dataView.setUint16(0, uintValue, true);
        } else if (4 === bufferSize) {
          dataView.setUint32(0, uintValue, true);
        } else {
          throw new Error('Unexpected bufferSize ' + bufferSize);
        }

        return new Uint8Array(buffer);
      } catch (e) {
        throw new Error("Converting uint value " + uintValue + " into buffer with error: " + e);
      }
    }
  }, {
    key: "uint8ToBuffer",
    value: function uint8ToBuffer(uintValue) {
      return GeneratorUtils.uintToBuffer(uintValue, 1);
    }
  }, {
    key: "uint16ToBuffer",
    value: function uint16ToBuffer(uintValue) {
      return GeneratorUtils.uintToBuffer(uintValue, 2);
    }
  }, {
    key: "uint32ToBuffer",
    value: function uint32ToBuffer(uintValue) {
      return GeneratorUtils.uintToBuffer(uintValue, 4);
    }
  }, {
    key: "notNull",
    value: function notNull(value, message) {
      if (value === undefined || value === null) {
        throw new Error(message);
      }
    }
  }, {
    key: "bufferToUint",
    value: function bufferToUint(buffer, size) {
      var dataView = new DataView(buffer.buffer);

      try {
        if (1 === size) {
          return dataView.getUint8(0);
        } else if (2 === size) {
          return dataView.getUint16(0, true);
        } else if (4 === size) {
          return dataView.getUint32(0, true);
        }

        throw new Error('Unexpected size ' + size);
      } catch (e) {
        throw new Error("Converting buffer into number with error:" + e);
      }
    }
  }, {
    key: "bufferToUint8",
    value: function bufferToUint8(buffer) {
      return GeneratorUtils.bufferToUint(buffer, 1);
    }
  }, {
    key: "bufferToUint16",
    value: function bufferToUint16(buffer) {
      return GeneratorUtils.bufferToUint(buffer, 2);
    }
  }, {
    key: "bufferToUint32",
    value: function bufferToUint32(buffer) {
      return GeneratorUtils.bufferToUint(buffer, 4);
    }
  }, {
    key: "uint64ToBuffer",
    value: function uint64ToBuffer(uintValue) {
      var uint32Array = new Uint32Array(GeneratorUtils.fromUint(uintValue));
      return new Uint8Array(uint32Array.buffer);
    }
  }, {
    key: "concatTypedArrays",
    value: function concatTypedArrays(array1, array2) {
      var newArray = new Uint8Array(array1.length + array2.length);
      newArray.set(array1);
      newArray.set(array2, array1.length);
      return newArray;
    }
  }, {
    key: "getBytes",
    value: function getBytes(binary, size) {
      if (size > binary.length) {
        throw new RangeError();
      }

      var bytes = binary.slice(0, size);
      return bytes;
    }
  }, {
    key: "getPaddingSize",
    value: function getPaddingSize(size, alignment) {
      if (alignment === 0) {
        return 0;
      }

      return 0 === size % alignment ? 0 : alignment - size % alignment;
    }
  }, {
    key: "getSizeWithPadding",
    value: function getSizeWithPadding(size, alignment) {
      return size + GeneratorUtils.getPaddingSize(size, alignment);
    }
  }, {
    key: "compact",
    value: function compact(uint64) {
      if (Array.isArray(uint64)) {
        var low = uint64[0];
        var high = uint64[1];

        if (0x00200000 <= high) {
          throw new Error('Cannot compact number: ' + uint64);
        }

        return high * 0x100000000 + low;
      } else {
        return uint64;
      }
    }
  }, {
    key: "fromUint",
    value: function fromUint(number) {
      if (Array.isArray(number)) {
        return number;
      }

      return [(number & 0xffffffff) >>> 0, number / 0x100000000 >>> 0];
    }
  }, {
    key: "loadFromBinary",
    value: function loadFromBinary(_loadFromBinary, payload, count) {
      var byteArray = Array.from(payload);
      var values = [];

      for (var i = 0; i < GeneratorUtils.compact(count); i++) {
        var item = _loadFromBinary(Uint8Array.from(byteArray));

        var itemSize = item.getSize();
        values.push(item);
        byteArray.splice(0, itemSize);
      }

      return values;
    }
  }, {
    key: "loadFromBinaryEnums",
    value: function loadFromBinaryEnums(payload, count, itemSize) {
      var byteArray = Array.from(payload);
      var values = [];

      for (var i = 0; i < GeneratorUtils.compact(count); i++) {
        values.push(GeneratorUtils.bufferToUint(payload, 2));
        byteArray.splice(0, itemSize);
      }

      return values;
    }
  }, {
    key: "loadFromBinaryRemaining",
    value: function loadFromBinaryRemaining(loadFromBinary, payload, payloadSize, alignment) {
      var byteArray = Array.from(payload);
      var remainingByteSizes = payloadSize;
      var transactions = [];

      while (remainingByteSizes > 0) {
        var item = loadFromBinary(Uint8Array.from(byteArray));
        transactions.push(item);
        var size = item.getSize();
        var itemSize = size + GeneratorUtils.getPaddingSize(item.getSize(), alignment);
        remainingByteSizes -= itemSize;
        byteArray.splice(0, itemSize);
      }

      return transactions;
    }
  }, {
    key: "writeList",
    value: function writeList(elements, alignment) {
      return elements.reduce(function (newArray, item) {
        var byte = item.serialize();
        var padding = new Uint8Array(GeneratorUtils.getPaddingSize(byte.length, alignment));
        return GeneratorUtils.concatTypedArrays(newArray, GeneratorUtils.concatTypedArrays(byte, padding));
      }, Uint8Array.from([]));
    }
  }, {
    key: "writeListEnum",
    value: function writeListEnum(elements, alignment) {
      return elements.reduce(function (newArray, item) {
        var byte = GeneratorUtils.uint16ToBuffer(item);
        var padding = new Uint8Array(GeneratorUtils.getPaddingSize(byte.length, alignment));
        return GeneratorUtils.concatTypedArrays(newArray, GeneratorUtils.concatTypedArrays(byte, padding));
      }, Uint8Array.from([]));
    }
  }, {
    key: "toFlags",
    value: function toFlags(enumClass, bitMaskValue) {
      var values = Object.keys(enumClass).map(function (key) {
        return enumClass[key];
      }).filter(function (k) {
        return parseInt(k) >= 0;
      }).map(function (k) {
        return parseInt(k);
      });
      return values.filter(function (value) {
        return (value & bitMaskValue) !== 0;
      });
    }
  }, {
    key: "fromFlags",
    value: function fromFlags(enumClass, flags) {
      var values = Object.keys(enumClass).map(function (key) {
        return enumClass[key];
      }).filter(function (k) {
        return parseInt(k) >= 0;
      }).map(function (k) {
        return parseInt(k);
      });
      return flags.filter(function (f) {
        return values.indexOf(f) > -1;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }
  }]);

  return GeneratorUtils;
}();

exports.GeneratorUtils = GeneratorUtils;

GeneratorUtils.uint8ToInt8 = function (input) {
  if (0xff < input) {
    throw Error("input '" + input + "' is out of range");
  }

  return input << 24 >> 24;
};